// A weathered log washed up on the sand: one main bleached trunk lying on its
// side with a smaller broken branch beside it. Ported 1:1 from age-of-mcp's
// classic driftwood.ts.
import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

function partsFor(): Part[] {
  return [
    { geometry: new THREE.CylinderGeometry(0.056, 0.067, 0.46, 6),
      color: "#a78867", position: [0, 0.062, 0],
      rotation: [0, 0.3, Math.PI / 2] },
    { geometry: new THREE.CylinderGeometry(0.028, 0.036, 0.18, 5),
      color: "#8a6a4a", position: [0.13, 0.07, 0.078],
      rotation: [0.4, 1.0, Math.PI / 2 - 0.5] },
  ];
}

export const driftwood = defineModel({
  id: "driftwood",
  batchId: "standard",
  name: "Driftwood",
  tags: ["scenery","driftwood","low-poly","age-of-mcp","classic","water"],
  summary: "Low-poly driftwood.",
  description: "Ported from the age-of-mcp gallery.",
  author: "age-of-mcp",
  footprint: 0.26,
  parts: () => partsFor(),
  animations: [],
});
